import React, { useEffect, useState } from 'react';
import { Container, Row, Col, ListGroup, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import {
  getMsteams,
  getMsteamChannels,
  setMsteamChannel,
} from '../../services';
import {
  setIntegrationAvailable,
  setIntegrationData,
  setIntegrationActiveInstance,
} from '../../redux/slices/integrationsSlice';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectMsteamsAvailable,
  selectMsteamsChannels,
  selectMsteamsInstances,
  selectMsteamsActiveInstanceId,
} from '../../redux/selectors/integrationsSelectors';
import { selectAuthToken } from '../../redux/selectors/authSelectors';

const MsteamChannel = () => {
  const dispatch = useDispatch();
  const token = useSelector(selectAuthToken);
  const msteamAvailable = useSelector(selectMsteamsAvailable);
  const msTeamChannels = useSelector(selectMsteamsChannels);
  const msTeamInstances = useSelector(selectMsteamsInstances);
  const msteamActive = useSelector(selectMsteamsActiveInstanceId);

  const [checkedItems, setCheckedItems] = useState([]); //plain object as state

  const handleChannelUpdate = (event) => {
    // updating an object instead of a Map
    const activeChannels = msTeamChannels.map((channel) => {
      if (event.target.name === channel.channelId) {
        if (!channel.applicationChannel) {
          channel.applicationChannel = true;
        } else {
          channel.applicationChannel = false;
        }
      }
      return channel;
    });
    dispatch(
      setIntegrationData({
        id: 'msteams',
        data: { channels: activeChannels },
      })
    );
    setCheckedItems({
      ...checkedItems,
      [event.target.name]: event.target.checked,
    });
  };

  useEffect(() => {
    if (!msteamAvailable) {
      getMsteams(token).then((res) => {
        if (res && res.status === 200 && res?.teams?.length) {
          dispatch(
            setIntegrationData({
              id: 'msteams',
              data: { instances: res.teams },
            })
          );
          const activeTeam = res.teams.filter(
            ({ applicationTeam }) => applicationTeam === true
          );
          if (activeTeam?.length) {
            const teamId = activeTeam[0].teamId;
            dispatch(
              setIntegrationActiveInstance({ id: 'msteams', instanceId: teamId })
            );
            getMsteamChannels(teamId).then((res) => {
              if (res && res.status === 200 && res?.channels?.length) {
                const ms_channel = res.channels.filter(
                  ({ applicationChannel }) => applicationChannel === true
                );
                dispatch(
                  setIntegrationData({
                    id: 'msteams',
                    data: { channels: ms_channel },
                  })
                );
              }
            });
          }
        }
      });
    }
  }, [token, msteamAvailable, dispatch]);

  useEffect(() => {
    if (msteamActive) {
      getMsteamChannels(msteamActive).then((res) => {
        if (res && res.status === 200 && res?.channels?.length) {
          dispatch(
            setIntegrationData({
              id: 'msteams',
              data: { channels: res.channels },
            })
          );
          
        }
      });
    }
  }, [token, msteamActive, dispatch]);

  const handleJoinClick = () => {
    const selChannels = Object.keys(checkedItems).filter(
      (key) => checkedItems[key] === true
    );

    setMsteamChannel(selChannels, msteamActive).then((status) => {
      if (status === true) {
        toast.success('Success: Set channel(s) as indicated', {
          position: 'top-right',
          autoClose: 4000,
        });
        dispatch(
          setIntegrationAvailable({ id: 'msteams', available: true })
        );
      } else {
        toast.error('An error occurred saving your channel selection.', {
          position: 'top-right',
          autoClose: 4000,
        });
      }
    });
  };

  return (
    <Container>
      <Row>
        <Col lg={12} className='mt-4 slack_channel_wrap'>
          {msTeamInstances?.length && <div>
            <h3 className='slack_channellist_heading'>
              Confirm Your Microsoft Teams Instance to Connect with
            </h3>
            <ul className='ms-team-instance'>
              <Form>
                {msTeamInstances?.length &&
                  msTeamInstances.map(({ teamId, applicationTeam, name }) => (
                    <li
                      key={teamId}
                      data-teamid={teamId}
                      className={`msteam-name ${applicationTeam ? 'active' : ''
                        }`}
                    >
                      <Form.Check type='checkbox' id={teamId}>
                        <Form.Check.Input
                          type='checkbox'
                          name={teamId}
                          defaultChecked={applicationTeam}
                          onChange={(event) => {
                            dispatch(
                              setIntegrationActiveInstance({
                                id: 'msteams',
                                instanceId: event.target.name,
                              })
                            );
                          }}
                        />
                        <Form.Check.Label>
                          <div className='ms-2 me-auto'>
                            <div
                              className='fw-bold'
                              style={{ fontSize: '1.2em' }}
                            >
                              {name}
                            </div>
                          </div>
                        </Form.Check.Label>
                      </Form.Check>
                    </li>
                  ))}
              </Form>
            </ul>
          </div>}
          {msTeamInstances && msTeamChannels && msTeamChannels.length ? (
            <div className='channellist-wrap'>
              <h3 className='slack_channellist_heading'>
                Choose Microsoft Teams Channels
              </h3>
              <p>
                This is where your team will see shared documents and other
                messages.
              </p>
              <ListGroup as='ol' numbered>
                <Form>
                  {msTeamChannels.map(
                    ({
                      channelId,
                      name,
                      topic,
                      purpose,
                      applicationChannel,
                    }) => (
                      <ListGroup.Item
                        as='li'
                        className={`d-flex justify-content-between align-items-start ${applicationChannel ? 'active' : ''
                          }`}
                        key={channelId}
                      >
                        <Form.Check type='checkbox' id={channelId}>
                          <Form.Check.Input
                            type='checkbox'
                            name={channelId}
                            defaultChecked={applicationChannel}
                            onChange={handleChannelUpdate}
                          />
                          <Form.Check.Label>
                            <div className='ms-2 me-auto'>
                              <div
                                className='fw-bold'
                                style={{ fontSize: '1.2em' }}
                              >
                                {name}
                              </div>
                              {topic}
                              {purpose && purpose !== '' ? (
                                <div>({purpose})</div>
                              ) : null}
                            </div>
                          </Form.Check.Label>
                        </Form.Check>
                      </ListGroup.Item>
                    )
                  )}
                </Form>
                <button
                  className='slack-join-channel-btn'
                  onClick={handleJoinClick}
                >
                  Join Now
                </button>
              </ListGroup>
            </div>
          ) :
            <div style={{ textAlign: "center", marginTop: "20px", opacity: 0.8 }}>
              <h5>No Microsoft Teams Instance found</h5>
              <p style={{ maxWidth: "775px", margin: "0 auto" }}>
                It looks like Microsoft Teams isn’t connected or there are no Microsoft Teams Instances available.
                <br /> Please check your Microsoft Teams connection under{" "}
                <strong>Integrations → Configuration</strong> and reconnect your workspace.
              </p>
            </div>
          }
        </Col>
      </Row>
    </Container>
  );
};

export default MsteamChannel;
